import React, { Fragment } from 'react';
import styled from 'styled-components';
import { serviceRequestVerbiage } from 'helpers/VerbiageHelper';
import { getCurrentLocale, getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';
import { media } from 'helpers/MediaHelper';

import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Divider from 'components/ui/Divider';
import { toFriendlyDateString } from 'helpers/Formatter';

const StyledContainer = styled.div``;

const StyledTitleText = styled.div`
  font-weight: 500;
  font-size: 24px;
  ${media.mobile`
    max-width: 300px;
  `};
`;

const StyledBodyText = styled.div`
  font-size: 16px;
  color: #626466;
`;

const StyledHeaderText = styled.div`
  font-size: 18px;
  color: #626466;
`;

const StyledColumnText = styled.div`
  font-weight: 500;
  font-size: 18px;
`;

const StyledRequestText = styled.div`
  font-weight: 400;
  font-size: 18px;
  color: ${colors.BATTLESHIP_GREY};
  padding-top: 40px;
`;

const StyledCompleteByText = styled.div`
  font-weight: 400;
  font-size: 18px;
  color: ${colors.BATTLESHIP_GREY};
`;

const StyledDividerMT10 = styled(Divider)`
  margin-top: 10px;
  margin-bottom: 10px;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.06);
`;

const VerticalLine = styled.div`
  background: #e0e0e0;
  width: 2px;
  height: 56px;
`;

const TicketDetails = ({
  ticket_number,
  property_name,
  address,
  subject,
  description,
  request_type,
  priority,
  complete_by,
}) => (
  <StyledContainer>
    <Spacer mb={1}>
      <StyledTitleText>
        {getTranslatedString('maintenanceVendors.title', {
          requestVerbiage: serviceRequestVerbiage(),
        })}
      </StyledTitleText>
      <StyledBodyText>
        {getTranslatedString('maintenanceVendors.body', {
          ticket_number,
          address,
          requestVerbiage: serviceRequestVerbiage(),
        })}
      </StyledBodyText>
      <StyledRequestText>
        {getTranslatedString('maintenanceVendors.requestNum', {
          ticket_number,
          requestVerbiage: serviceRequestVerbiage('capitalized'),
        })}
      </StyledRequestText>
      <StyledColumnText>{subject}</StyledColumnText>
      <StyledDividerMT10 orientation="center" />
      {complete_by && (
        <Fragment>
          <StyledCompleteByText>
            {getTranslatedString('maintenanceVendors.completeBy')}
          </StyledCompleteByText>
          <StyledColumnText>
            {toFriendlyDateString(complete_by, getCurrentLocale())}
          </StyledColumnText>
          <StyledDividerMT10 orientation="center" />
        </Fragment>
      )}
      <Row gutter={16}>
        <Col span={11}>
          <StyledHeaderText>
            {getTranslatedString('maintenanceVendors.requestType')}
          </StyledHeaderText>
          <StyledColumnText>{request_type}</StyledColumnText>
        </Col>
        <Col span={1}>
          <VerticalLine />
        </Col>
        <Col span={11}>
          <StyledHeaderText>{getTranslatedString('maintenanceVendors.priority')}</StyledHeaderText>
          <StyledColumnText>{priority}</StyledColumnText>
        </Col>
      </Row>
    </Spacer>
    <StyledDividerMT10 orientation="center" />
  </StyledContainer>
);

export default TicketDetails;
